import { HttpClient, HttpParams } from '@angular/common/http';
import { Component, ElementRef, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { environment } from 'src/environments/environment';
import * as XLSX from 'xlsx';
import Swal from 'sweetalert2/dist/sweetalert2.js';

@Component({
  selector: 'app-antidumping',
  templateUrl: './antidumping.component.html',
  styleUrls: ['./antidumping.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AntidumpingComponent implements OnInit {

  NotifyNum: string;
  SerialNum: string;
  EffectDate: string;
  description: string;
  isShownError: boolean = true;
  isShownSuccess: boolean = true;
  Status: boolean = false;
  ErrorMsg: string;
  SuccessMsg: string;
  isShownSaveBtn: boolean = false;
  isShownUpdateBtn: boolean = true;
  isShownActive: Boolean = true;
  public searchText: string;
  CustNotifyExport = [] as any;
  EditedCustNotify = [] as any;
  EditedAntiDumpId: string;
  imageurl: string;
  myfile: string;
  imgfile: File;
  myFiles: string[] = [];
  doclist: string;
  surl: string;
  selects = [] as any;
  isShowndoclist: boolean = true;
  EditedDoc = [] as any;
  EditedDocId: string;
  isShownExcel: boolean = true;
  isShownPdf: boolean = true;
  isShownimage: boolean = true;
  lblname: string;
  vRead: string;
  vWrite: string;
  isShownWrite: boolean = true;
  sOnboardingId: string;

  @ViewChild('file')
  myInputVariable: ElementRef;

  displayedColumns: string[] = ['sno', 'notifynum', 'serialnum', 'datetime1', 'status'];
  dataSource: MatTableDataSource<any[]>;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('TABLE') table: ElementRef;


  constructor(private http: HttpClient) { }

  ngOnInit(): void {
    this.vRead = localStorage.getItem('AntiDumbingRead');
    this.vWrite = localStorage.getItem('AntiDumbingWrite');
    if ((this.vRead == undefined || this.vRead == "") && (this.vWrite == undefined || this.vWrite == ""))
      window.location.href = '/Dashboard';
    if (this.vWrite != undefined && this.vWrite != "") {
      if (this.vWrite == "True")
        this.isShownWrite = false;
    }
    this.sOnboardingId = localStorage.getItem('OnboardingId');
    // if (this.sOnboardingId == undefined || this.sOnboardingId == null || this.sOnboardingId == "0") {
    //   Swal.fire('','Please Select A Customer First!');
    // }
    this.BindCustGrid();
    this.BindCustNotifyExport();
  }

  public uploadFile = (files) => {
    this.isShownError = true;
    this.isShownSuccess = true;
    this.ErrorMsg = "";
    this.SuccessMsg = "";

    debugger;
    if (files.length == 0) {
      return;
    }
    for (var i = 0; i < files.length; i++) {
      this.myFiles.push(files[i]);
    }
    debugger;
    //let fileToUpload = <File>files[0];
    const formData = new FormData();
    //formData.append('file', fileToUpload, fileToUpload.name);
    for (var i = 0; i < this.myFiles.length; i++) {
      formData.append("file[]", this.myFiles[i]);
    }

    this.http.post(environment.apiUrl + 'AntiDump/UploadContent', formData).subscribe(
      (response) => {
        debugger;
        alert(response);
      },
      (error) => {
        debugger;
        var vDataError = JSON.stringify(error.error.text);
        var vErrorMsg = vDataError.replace('"', '');       
        var vErrorMsg1 = vErrorMsg.replace('"', '');
        if (vErrorMsg1 == "Failed") {
          this.isShownError = false;
          this.ErrorMsg = "Upload Failed, Please Try Again.";
          return false;
        }
        else{
          this.surl = vErrorMsg1;
          var spliturl = vErrorMsg1.split(",");
          for (var i = 0; i < spliturl.length; i++) {
            this.isShownimage = false;
            this.isShowndoclist = false;
            var furl = spliturl[i];
            var cvname = furl.split("/");
            var fname = cvname[7];
            this.selects.push({ filename: fname, fileURL: furl });
            this.imageurl = furl;
            this.isShownSuccess = false;
            this.SuccessMsg = "File Uploaded"
            this.myFiles = [];
            this.myInputVariable.nativeElement.value = "";
          }
        }       
      }
    )

  }

  SubmitNotify() {
    this.sOnboardingId = localStorage.getItem('OnboardingId');
    if (this.sOnboardingId == undefined || this.sOnboardingId == null || this.sOnboardingId == "0") {
      Swal.fire('','Please Select A Customer First!');
      return;
    }
    this.isShownError = true;
    this.isShownSuccess = true;
    this.ErrorMsg = "";
    this.SuccessMsg = "";
    this.Status = false;
    var vNotifyNum = this.NotifyNum;
    var vSerialNum = this.SerialNum;
    var vEffectDate = this.EffectDate;
    var vDescription = this.description;
    debugger;

    if (vNotifyNum == undefined || vNotifyNum == "" || vNotifyNum == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Notification Number.";
      return false;
    }

    if (vSerialNum == undefined || vSerialNum == "" || vSerialNum == "0") {
      this.SerialNum = "";
    }
    if (vEffectDate == undefined || vEffectDate == "" || vEffectDate == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Effective Date.";
      return false;
    }
    if (vDescription == undefined || vDescription == "" || vDescription == "0") {
      this.description = "";
    }

    let params = new HttpParams();
    params = params.append('dNotifyNum', this.NotifyNum);
    params = params.append('dSerialNum', this.SerialNum);
    params = params.append('dEffectDate', this.EffectDate);
    params = params.append('ddescription', this.description);
    var value = this.http.get(environment.apiUrl + 'AntiDump/InsertAntiDump', { params: params }).toPromise().then(
      (data: any) => {
        debugger;
        var customnotifyId = data;
        var spliturl = this.surl;
        debugger;
        if (spliturl != undefined && spliturl != "") {
        let params3 = new HttpParams();
        params3 = params3.append('sAntiDumpId', customnotifyId);
        params3 = params3.append('sfurl', spliturl);
        var value2 = this.http.get(environment.apiUrl + 'AntiDump/InsertAntiDumpDoc', { params: params3 }).toPromise().then(
          (data: any) => {
            var Custnotfy = data;
            this.NotifyNum = "";
            this.SerialNum = "";
            this.EffectDate = "";
            this.description = "";
            this.imageurl = "";
            this.isShownimage = true;
            this.isShownPdf = true;
            this.isShownExcel = true;
            this.myFiles = [];
            this.selects = [];
            this.surl = "";
            this.isShownSuccess = false;
            this.SuccessMsg = "AntiDumping Added."
            this.BindCustGrid();
            this.BindCustNotifyExport();
            return false;
          }).catch((data: any) => {
            debugger;
            var vDataError = JSON.stringify(data.error.text);
            var vErrorMsg = vDataError.replace('"', '');
            var vErrorMsg1 = vErrorMsg.replace('"', '');
            if (vErrorMsg1 == "Failed") {
              this.isShownError = false;
              this.ErrorMsg = "Insert Failed, Please Try Again.";
              return false;
            }
            else {
            }
          });
        }
        else{
          var Custnotfy = data;
          this.NotifyNum = "";
          this.SerialNum = "";
          this.EffectDate = "";
          this.description = "";
          this.imageurl = "";
          this.isShownimage = true;
          this.isShownPdf = true;
          this.isShownExcel = true;
          this.myFiles = [];
          this.selects = [];
          this.surl = "";
          this.isShownSuccess = false;
          this.SuccessMsg = "AntiDumping Added."
          this.BindCustGrid();
          this.BindCustNotifyExport();
          return false;
        }
      }).catch((data: any) => {
        debugger;
        var vDataError = JSON.stringify(data.error.text);
        var vErrorMsg = vDataError.replace('"', '');
        var vErrorMsg1 = vErrorMsg.replace('"', '');
        if (vErrorMsg1 == "Failed") {
          this.isShownError = false;
          this.ErrorMsg = "Insert Failed, Please Try Again.";
          return false;
        }
        else  if (vErrorMsg1 == "Exist") {
          this.isShownError = false;
          this.ErrorMsg = "Notification Number Already Exist.";
          return false;
        }
        else {
        }
      });

  }


  EditCustNotify(item: any) {
    this.isShownSaveBtn = true;
    this.isShownUpdateBtn = false;
    this.isShownActive = false;
    this.isShownError = true;
    this.isShownSuccess = true;
    this.EditedCustNotify = item;
    var vNotifyId = this.EditedCustNotify.notifyid;
    var vnotifynum = this.EditedCustNotify.notifynum;
    var vserialnum = this.EditedCustNotify.serialnum;
    var vdateTime = this.EditedCustNotify.dateTime;
    var vdescription = this.EditedCustNotify.description;


    this.EditedAntiDumpId = vNotifyId;
    this.NotifyNum = vnotifynum;
    this.SerialNum = vserialnum;
    this.EffectDate = new Date(new Date(vdateTime).setDate(new Date(vdateTime).getDate() + 1)).toISOString().split('T')[0];
    this.selects = [];
    var value3 = this.http.get(environment.apiUrl + 'AntiDump/GetDocForEdit?CustNotifyID=' + vNotifyId).toPromise().then(
      (data: any) => {
        debugger;
        if (data.length != 0) {
          var vData1 = data;
          debugger;
          for (var i = 0; i < vData1.length; i++) {
            this.EditedDoc = vData1[i];
            var vdocId = this.EditedDoc.cdocId;
            var vdocurl = this.EditedDoc.docUrl;
            var furl = vdocurl;
            this.isShownimage = false;
            this.isShowndoclist = false;
            var cvname = furl.split("/");
            var fname = cvname[6];
            this.selects.push({ docid: vdocId, filename: fname, fileURL: furl });
          }

        }
      });
    this.description = vdescription;
    var vStatus = this.EditedCustNotify.status;
    debugger;
    if (vStatus == "Active") {
      this.Status = false;
    }
    else {
      this.Status = true;
    }
  }

  UpdateNotify() {
    this.isShownError = true;
    this.isShownSuccess = true;
    this.isShownActive = true;
    this.ErrorMsg = "";
    this.SuccessMsg = "";
    var vNotifyNum = this.NotifyNum;
    var vSerialNum = this.SerialNum;
    var vEffectDate = this.EffectDate;
    var vDescription = this.description;
    debugger;

    if (vNotifyNum == undefined || vNotifyNum == "" || vNotifyNum == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Notification Number.";
      return false;
    }

    if (vSerialNum == undefined || vSerialNum == "" || vSerialNum == "0") {
      this.SerialNum = "";
    }
    if (vEffectDate == undefined || vEffectDate == "" || vEffectDate == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Effective Date.";
      return false;
    }
    if (vDescription == undefined || vDescription == "" || vDescription == "0") {
      this.description = "";
    }

    var vStatus = "Active";
    if (this.Status == true)
      vStatus = "InActive";
    else
      vStatus = "Active";

    let params = new HttpParams();
    params = params.append('iNotifyNum', this.NotifyNum);
    params = params.append('iSerialNum', this.SerialNum);
    params = params.append('iEffectDate', this.EffectDate);
    params = params.append('idescription', this.description);
    params = params.append('iAntiDumpId', this.EditedAntiDumpId);
    params = params.append('istatus', vStatus);
    var value = this.http.get(environment.apiUrl + 'AntiDump/UpdateAntiDumping', { params: params }).toPromise().then(
      (data: any) => {
        debugger;
        var AntiDumpId = this.EditedAntiDumpId;
        var spliturl = this.surl;
        debugger;
        if (spliturl != undefined && spliturl != "") {
          let params3 = new HttpParams();
          params3 = params3.append('sAntiDumpId', AntiDumpId);
          params3 = params3.append('sfurl', spliturl);
          debugger;
          var value2 = this.http.get(environment.apiUrl + 'AntiDump/InsertAntiDumpDoc', { params: params3 }).toPromise().then(
            (data: any) => {
              debugger;
              this.isShownSaveBtn = false;
              this.isShownUpdateBtn = true;
              this.NotifyNum = "";
              this.SerialNum = "";
              this.EffectDate = "";
              this.description = "";
              this.isShownimage = true;
              this.isShownPdf = true;
              this.isShownExcel = true;
              this.myFiles = [];
              this.selects = [];
              this.imageurl = "";
              this.surl = "";
              this.isShownSuccess = false;
              this.SuccessMsg = "AntiDumping Updated."
              this.BindCustGrid();
              this.BindCustNotifyExport();
              return false;
            }).catch((data: any) => {
              debugger;
              var vDataError = JSON.stringify(data.error.text);
              var vErrorMsg = vDataError.replace('"', '');
              var vErrorMsg1 = vErrorMsg.replace('"', '');
              if (vErrorMsg1 == "Failed") {
                this.isShownError = false;
                this.ErrorMsg = "Update Failed, Please Try Again.";
                return false;
              }
              else {
              }
            });
        }
        else {
          this.isShownSaveBtn = false;
          this.isShownUpdateBtn = true;
          this.NotifyNum = "";
          this.SerialNum = "";
          this.EffectDate = "";
          this.description = "";
          this.isShownimage = true;
          this.isShownPdf = true;
          this.isShownExcel = true;
          this.myFiles = [];
          this.selects = [];
          this.imageurl = "";
          this.surl = "";
          this.isShownSuccess = false;
          this.SuccessMsg = "AntiDumping Updated."
          this.BindCustGrid();
          this.BindCustNotifyExport();
          return false;
        }
      }).catch((data: any) => {
        debugger;
        var vDataError = JSON.stringify(data.error.text);
        var vErrorMsg = vDataError.replace('"', '');
        var vErrorMsg1 = vErrorMsg.replace('"', '');
        if (vErrorMsg1 == "Failed") {
          this.isShownError = false;
          this.ErrorMsg = "Update Failed, Please Try Again.";
          return false;
        }
        else {
        }
      });

  }

  ClearNotify() {
    this.isShownError = true;
    this.isShownSuccess = true;
    this.isShownActive = true;
    this.Status = false;
    this.ErrorMsg = "";
    this.SuccessMsg = "";
    this.isShownSaveBtn = false;
    this.isShownUpdateBtn = true;
    this.NotifyNum = "";
    this.SerialNum = "";
    this.EffectDate = "";
    this.description = "";
    this.myfile = "";
    this.isShownPdf = true;
    this.isShownExcel = true;
    this.isShownimage = true;
    this.myFiles = [];
    this.selects = [];
    this.imageurl = "";
    this.surl = "";


  }

  BindCustGrid() {
    // this.sOnboardingId = localStorage.getItem('OnboardingId');
    // let params = new HttpParams();
    // params = params.append('iOnboardingId', this.sOnboardingId);
    var value = this.http.get(environment.apiUrl + 'AntiDump/GetAntiDumpForGrid').toPromise().then(
      (data: any) => {
        debugger;
        this.dataSource = new MatTableDataSource(data);
        this.dataSource.data = data;
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;

      });
  }

  applyFilter(filterValue: string) {
    debugger;
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }

  BindCustNotifyExport() {
    // this.sOnboardingId = localStorage.getItem('OnboardingId');
    // let params = new HttpParams();
    // params = params.append('iOnboardingId', this.sOnboardingId);
    var value = this.http.get(environment.apiUrl + 'AntiDump/GetAntiDumpForExport').toPromise().then(
      (data: any) => {
        debugger;
        this.CustNotifyExport = data;
      });
  }

  exportexcel(): void {
    debugger;
    /* table id is passed over here */
    const workSheet = XLSX.utils.json_to_sheet(this.CustNotifyExport);
    const workBook: XLSX.WorkBook = XLSX.utils.book_new();
    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, workSheet, 'AntiDumping');

    /* save to file */
    XLSX.writeFile(wb, "AntiDumping.xlsx");

  }

  RemoveDocument(item: any,index) {

    Swal.fire({
      title: 'Are you sure?',
      text: 'You want to remove this File!',

      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it'
    }).then((result) => {
      if (result.value) {
        this.selects.splice(index,1);
        if(item.docid == undefined)
{
  let params = new HttpParams();
    params = params.append('lDocumentId', item.docid);
    var value = this.http.get(environment.apiUrl + 'AntiDump/DeletFromAntiDumpingDoc', { params: params }).toPromise().then(
      (data: any) => {
       
        var returnValue = data;
        return false;
      }).catch((data: any) => {
        
        var vDataError = JSON.stringify(data.error.text);
       
              var vErrorMsg = vDataError.replace('"', '');
        var vErrorMsg1 = vErrorMsg.replace('"', '');
        if (vErrorMsg1 == "Failed") {
          this.isShownError = false;
          this.ErrorMsg = "Delete Failed, Please Try Again.";
          return false;
        }
        else if(vErrorMsg1 == "Success")
        {
          
          return false;
  
        }

  


  });
}

      } else if (result.dismiss === Swal.DismissReason.cancel) {
        
      }
    })
     
  

  }


}
